import {GraphQLClient} from "graphql-request";
import {getEnviroment} from "../../../env";
import {RequestDocument, Variables} from "graphql-request/dist/types";

export function queryData<T = any>(queryName: string, document: RequestDocument, variables: Variables, idToken?: string) : Promise<T> {
    const client = new GraphQLClient(`${getEnviroment().endpoints.graphQlManager}/${queryName}`, { headers: { Authorization: `Bearer ${idToken}`, "TU-PREVIEW": "TIME-EXCAVATORS" } });
    return client.request<any>(document, variables);
}
